/**
 * Feature Flags Configuration
 * 
 * Centralized feature flag management for A2A integration.
 * Flags are loaded from environment variables.
 */

/**
 * Feature Flags
 * 
 * These flags control the behavior of the application:
 * - USE_A2A_BACKEND: Enable/disable A2A backend
 * - FALLBACK_TO_SUPABASE: Enable/disable Supabase fallback
 */
export const FeatureFlags = {
  /**
   * Enable A2A backend
   * Default: true (enabled by default)
   * Set to 'false' in env to use Supabase exclusively
   */
  USE_A2A_BACKEND: process.env.REACT_APP_USE_A2A_BACKEND !== 'false',
  
  /**
   * Enable Supabase fallback
   * Default: true (enabled by default)
   * If A2A fails and this is true, fallback to Supabase
   * If false, throw errors when A2A fails
   */
  FALLBACK_TO_SUPABASE: process.env.REACT_APP_FALLBACK_TO_SUPABASE !== 'false',
  
  /**
   * A2A Backend URL
   * URL of the A2A backend server
   */
  A2A_BACKEND_URL: process.env.REACT_APP_A2A_BACKEND_URL || 'https://a2aenglishai-server.appsokay.net',
  
  /**
   * A2A Secret Key
   * Secret key for message signing (optional)
   */
  A2A_SECRET_KEY: process.env.REACT_APP_A2A_SECRET_KEY || null,
  
  /**
   * Enable Logging
   * Automatically enabled in development mode
   */
  ENABLE_LOGGING: process.env.NODE_ENV === 'development',
};

/**
 * Feature Flag Status
 * Returns a human-readable status of feature flags
 */
export const getFeatureFlagStatus = () => {
  return {
    'A2A Backend': FeatureFlags.USE_A2A_BACKEND ? '✅ Enabled' : '❌ Disabled',
    'Supabase Fallback': FeatureFlags.FALLBACK_TO_SUPABASE ? '✅ Enabled' : '❌ Disabled',
    'Backend URL': FeatureFlags.A2A_BACKEND_URL,
    'Has Secret Key': FeatureFlags.A2A_SECRET_KEY ? '✅ Yes' : '❌ No',
    'Logging': FeatureFlags.ENABLE_LOGGING ? '✅ Enabled' : '❌ Disabled',
    'Environment': process.env.NODE_ENV,
  };
};

/**
 * Log feature flag status (development only)
 */
if (FeatureFlags.ENABLE_LOGGING) {
  console.log('=== Feature Flags ===');
  const status = getFeatureFlagStatus();
  Object.entries(status).forEach(([key, value]) => {
    console.log(`${key}: ${value}`);
  });
  console.log('====================');
}

export default FeatureFlags;

